var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6667C20.4434 25.6667 25.6667 20.4434 25.6667 14C25.6667 7.55672 20.4434 2.33337 14 2.33337C7.55672 2.33337 2.33337 7.55672 2.33337 14C2.33337 20.4434 7.55672 25.6667 14 25.6667Z",
    stroke: "#F14336",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9536 17.69C11.5422 18.0833 12.3614 18.0833 14 18.0833C15.6385 18.0833 16.4578 18.0833 17.0462 17.69C17.301 17.5198 17.5198 17.301 17.69 17.0462C18.0833 16.4578 18.0833 15.6385 18.0833 14C18.0833 12.3614 18.0833 11.5422 17.69 10.9536C17.5198 10.6989 17.301 10.4801 17.0462 10.3099C16.4578 9.91663 15.6385 9.91663 14 9.91663C12.3614 9.91663 11.5422 9.91663 10.9536 10.3099C10.6989 10.4801 10.4801 10.6989 10.3099 10.9536C9.91663 11.5422 9.91663 12.3614 9.91663 14C9.91663 15.6385 9.91663 16.4578 10.3099 17.0462C10.4801 17.301 10.6989 17.5198 10.9536 17.69Z",
    fill: "#F14336",
    stroke: "#F14336",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRecording);
export default __webpack_public_path__ + "static/media/stop-recording.eb341dfe4ff87b1c9e94fa2b8e05dd59.svg";
export { ForwardRef as ReactComponent };